import React from 'react';
import MobileAdhesionFs from './freestar/Adhesion';
const MobileAdhesion = ({ safety ='off' , safetyState  })=>{
    return /*#__PURE__*/ React.createElement(MobileAdhesionFs, {
        safety: safety,
        safetyState: safetyState
    });
};
MobileAdhesion.displayName = 'MobileAdhesion';
export default MobileAdhesion;
